import React from "react";
import { useNavigate } from "react-router-dom";

function CreatorSupportDemoPage() {
  const navigate = useNavigate();

  return (
    <div className="creator-page">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← Retour
      </button>

      <div className="grid-bg"></div>
      <div className="glow glow-one"></div>
      <div className="glow glow-two"></div>

      <div className="creator-visual">
        <div className="creator-avatar">
          <span>🎬</span>
        </div>

        <div className="income-line line-one">
          <strong>+50 coins</strong>
          <span>cadeau live</span>
        </div>

        <div className="income-line line-two">
          <strong>+120 coins</strong>
          <span>vidéo soutenue</span>
        </div>

        <div className="income-line line-three">
          <strong>+300 coins</strong>
          <span>communauté active</span>
        </div>

        <div className="wallet-card">
          <small>Solde créateur</small>
          <strong>1 470 coins</strong>
          <div className="wallet-bar">
            <span></span>
          </div>
        </div>
      </div>

      <div className="content">
        <p className="label">EVO CREATOR SUPPORT</p>

        <h1>Soutien créateur</h1>

        <p>
          Un système pensé pour aider les créateurs à monétiser leur audience
          grâce aux cadeaux, aux interactions et au soutien reçu pendant les
          lives ou sous les vidéos.
        </p>

        <div className="steps">
          <div>
            <strong>01</strong>
            <span>Le public soutient</span>
          </div>

          <div>
            <strong>02</strong>
            <span>Les coins s’accumulent</span>
          </div>

          <div>
            <strong>03</strong>
            <span>Le créateur est valorisé</span>
          </div>
        </div>
      </div>

      <style>{`
        .creator-page {
          position: fixed;
          inset: 0;
          overflow: hidden;
          background:
            radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%),
            radial-gradient(circle at bottom left, rgba(0,145,255,0.16), transparent 34%),
            linear-gradient(135deg, #02040a 0%, #03131d 48%, #02040a 100%);
          color: #fff;
          font-family: Arial, sans-serif;
        }

        .back-btn {
          position: absolute;
          top: 22px;
          left: 22px;
          z-index: 20;
          border: 1px solid rgba(0,242,255,0.55);
          background: rgba(0, 12, 20, 0.9);
          color: #00f2ff;
          padding: 11px 18px;
          border-radius: 16px;
          font-weight: 900;
          cursor: pointer;
          box-shadow: 0 0 20px rgba(0,242,255,0.35);
        }

        .grid-bg {
          position: absolute;
          inset: 0;
          opacity: 0.13;
          background-image:
            linear-gradient(rgba(0,242,255,0.18) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,242,255,0.18) 1px, transparent 1px);
          background-size: 42px 42px;
          animation: gridMove 18s linear infinite;
        }

        .glow {
          position: absolute;
          width: 360px;
          height: 360px;
          border-radius: 50%;
          filter: blur(85px);
          background: #00f2ff;
          opacity: 0.34;
          animation: glowFloat 5s ease-in-out infinite alternate;
        }

        .glow-one {
          top: -110px;
          left: 18%;
        }

        .glow-two {
          bottom: -130px;
          right: 10%;
          opacity: 0.24;
          animation-delay: 1.2s;
        }

        .creator-visual {
          position: absolute;
          left: 8%;
          top: 50%;
          transform: translateY(-50%);
          width: 430px;
          height: 540px;
          border-radius: 38px;
          background: rgba(0, 12, 20, 0.78);
          border: 1px solid rgba(0,242,255,0.34);
          box-shadow:
            0 0 45px rgba(0,242,255,0.24),
            inset 0 0 30px rgba(0,242,255,0.08);
          animation: panelIn 0.9s ease forwards;
        }

        .creator-avatar {
          position: absolute;
          top: 52px;
          left: 50%;
          transform: translateX(-50%);
          width: 145px;
          height: 145px;
          border-radius: 50%;
          border: 2px solid rgba(0,242,255,0.65);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 36px rgba(0,242,255,0.45);
          animation: avatarPulse 2s ease-in-out infinite;
        }

        .creator-avatar::after {
          content: "";
          position: absolute;
          width: 145px;
          height: 145px;
          border-radius: 50%;
          border: 1px solid rgba(0,242,255,0.35);
          animation: wave 2s linear infinite;
        }

        .creator-avatar span {
          font-size: 58px;
          filter: drop-shadow(0 0 16px rgba(0,242,255,0.75));
        }

        .income-line {
          position: absolute;
          min-width: 160px;
          padding: 14px 16px;
          border-radius: 20px;
          background: rgba(0, 20, 30, 0.92);
          border: 1px solid rgba(0,242,255,0.34);
          box-shadow: 0 0 24px rgba(0,242,255,0.18);
          animation: incomePop 4s ease-in-out infinite;
        }

        .income-line strong {
          display: block;
          color: #ffffff;
          font-size: 17px;
          margin-bottom: 5px;
        }

        .income-line span {
          color: #9befff;
          font-size: 13px;
        }

        .line-one {
          top: 215px;
          left: 28px;
        }

        .line-two {
          top: 282px;
          right: 28px;
          animation-delay: 0.65s;
        }

        .line-three {
          top: 350px;
          left: 58px;
          animation-delay: 1.3s;
        }

        .wallet-card {
          position: absolute;
          left: 32px;
          right: 32px;
          bottom: 32px;
          padding: 22px;
          border-radius: 26px;
          background:
            radial-gradient(circle at top, rgba(0,242,255,0.16), transparent 48%),
            rgba(0, 10, 16, 0.92);
          border: 1px solid rgba(0,242,255,0.38);
          box-shadow: 0 0 28px rgba(0,242,255,0.18);
        }

        .wallet-card small {
          display: block;
          color: #9befff;
          font-size: 13px;
          margin-bottom: 8px;
        }

        .wallet-card strong {
          display: block;
          font-size: 32px;
          color: #ffffff;
          text-shadow: 0 0 18px rgba(0,242,255,0.5);
        }

        .wallet-bar {
          height: 8px;
          margin-top: 18px;
          border-radius: 99px;
          background: rgba(255,255,255,0.08);
          overflow: hidden;
        }

        .wallet-bar span {
          display: block;
          height: 100%;
          width: 76%;
          border-radius: 99px;
          background: linear-gradient(90deg, #00f2ff, #009dff);
          animation: walletLoad 2.3s ease-in-out infinite;
        }

        .content {
          position: absolute;
          right: 8%;
          top: 50%;
          transform: translateY(-50%);
          max-width: 560px;
          animation: textIn 1s ease forwards;
        }

        .label {
          color: #00f2ff;
          font-weight: 900;
          letter-spacing: 4px;
          margin-bottom: 14px;
        }

        .content h1 {
          font-size: 58px;
          line-height: 1;
          margin: 0 0 22px;
          text-shadow: 0 0 35px rgba(0,242,255,0.65);
        }

        .content p {
          color: #bdefff;
          font-size: 20px;
          line-height: 1.65;
          margin-bottom: 30px;
        }

        .steps {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 14px;
        }

        .steps div {
          padding: 18px;
          border-radius: 22px;
          background: rgba(0, 12, 20, 0.78);
          border: 1px solid rgba(0,242,255,0.28);
          box-shadow: 0 0 22px rgba(0,242,255,0.12);
          animation: stepFloat 2.8s ease-in-out infinite;
        }

        .steps div:nth-child(2) {
          animation-delay: 0.3s;
        }

        .steps div:nth-child(3) {
          animation-delay: 0.6s;
        }

        .steps strong {
          display: block;
          color: #ffffff;
          font-size: 20px;
          margin-bottom: 8px;
        }

        .steps span {
          color: #9befff;
          font-size: 13px;
          line-height: 1.35;
        }

        @keyframes incomePop {
          0% {
            opacity: 0;
            transform: translateY(18px) scale(0.92);
          }
          22%, 72% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateY(-16px) scale(0.96);
          }
        }

        @keyframes walletLoad {
          0%, 100% {
            width: 48%;
          }
          50% {
            width: 88%;
          }
        }

        @keyframes avatarPulse {
          0%, 100% {
            transform: translateX(-50%) scale(1);
          }
          50% {
            transform: translateX(-50%) scale(1.06);
          }
        }

        @keyframes wave {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          100% {
            transform: scale(2.2);
            opacity: 0;
          }
        }

        @keyframes stepFloat {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes panelIn {
          from {
            opacity: 0;
            transform: translateY(-50%) translateX(-80px) scale(0.92);
          }
          to {
            opacity: 1;
            transform: translateY(-50%) translateX(0) scale(1);
          }
        }

        @keyframes textIn {
          from {
            opacity: 0;
            transform: translateY(-42%);
          }
          to {
            opacity: 1;
            transform: translateY(-50%);
          }
        }

        @keyframes gridMove {
          from {
            background-position: 0 0;
          }
          to {
            background-position: 84px 84px;
          }
        }

        @keyframes glowFloat {
          from {
            transform: translateY(0) scale(1);
          }
          to {
            transform: translateY(-35px) scale(1.12);
          }
        }

        @media (max-width: 900px) {
          .creator-visual {
            left: 50%;
            top: 39%;
            transform: translate(-50%, -50%);
            width: 310px;
            height: 430px;
          }

          .creator-avatar {
            width: 105px;
            height: 105px;
            top: 42px;
          }

          .creator-avatar::after {
            width: 105px;
            height: 105px;
          }

          .creator-avatar span {
            font-size: 42px;
          }

          .income-line {
            min-width: 132px;
            padding: 10px 12px;
          }

          .line-one {
            top: 162px;
            left: 18px;
          }

          .line-two {
            top: 222px;
            right: 18px;
          }

          .line-three {
            top: 282px;
            left: 38px;
          }

          .wallet-card {
            left: 20px;
            right: 20px;
            bottom: 20px;
            padding: 16px;
          }

          .wallet-card strong {
            font-size: 24px;
          }

          .content {
            left: 22px;
            right: 22px;
            top: auto;
            bottom: 28px;
            transform: none;
            text-align: center;
          }

          .content h1 {
            font-size: 35px;
          }

          .content p {
            font-size: 15px;
          }

          .steps {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
}

export default CreatorSupportDemoPage;
